import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: ({ color, hasInitialPriceDisplayed }) => ({
    thRoot: 'flex flex-wrap gap-x-10 isolate items-baseline relative text-14',
    thFirstLine: 'flex gap-x-10 items-baseline',
    thFrom: classnames('text-12 first-letter:uppercase', {
      'absolute top-0': hasInitialPriceDisplayed,
    }),
    thInitialPrice: `font-semibold line-through text-14 text-${color}`,
    thTotalPrice: 'font-semibold text-14 text-green',
    thBestPrice: 'font-bold text-32',
    thUnit: 'text-12',
  }),
  column: ({ color }) => ({
    thRoot: 'flex flex-col isolate leading-tight relative text-14',
    thFirstLine: 'flex gap-x-10 items-baseline',
    thFrom: 'first-letter:uppercase',
    thInitialPrice: `font-semibold line-through text-14 text-${color}`,
    thTotalPrice: 'font-semibold text-14 text-green',
    thBestPrice: 'font-bold text-20 sm:text-28 w-full',
    thUnit: 'text-12',
  }),
  inline: ({ color }) => ({
    thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
    thFirstLine: 'flex gap-x-5 items-baseline shrink-0',
    thFrom: 'first-letter:uppercase',
    thInitialPrice: `font-semibold line-through text-10 sm:text-12 text-${color}`,
    thTotalPrice: 'font-semibold text-14 text-green',
    thBestPrice: 'font-bold shrink-0 text-20 underline',
    thUnit: 'text-10 sm:text-12',
  }),
  inlineSmall: ({ color }) => ({
    thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
    thFirstLine: 'flex gap-x-5 items-baseline',
    thFrom: 'first-letter:uppercase',
    thInitialPrice: `font-semibold line-through text-10 sm:text-12 text-${color}`,
    thTotalPrice: 'font-semibold text-14 text-green',
    thBestPrice: 'font-bold text-14 sm:text-20',
    thUnit: 'text-10 sm:text-12',
  }),
};
